module.exports = __webpack_public_path__ + "static/media/left_logo.50c9bd3f.png";